import React, { Component } from 'react';
import { ReactComponent as ThumbsUpIcon } from '../../assets/thumbs_up.svg';
import './styles/Widget.css';

class Upvote extends Component {
	constructor(props) {
		super(props);
		this.state = {
			upvotes: null,
			unStyled: true
		};
	}
	// Color Handler
	colorHandler = () => {
		this.setState({ unStyled: !this.state.unStyled });
	};

	// GET request w/ error handling
	componentDidMount() {
		const url_id = window.location.pathname.replace(/^\/+/, '');
		fetch('https://thumbs.vercel.app/api?url_id=' + url_id)
			.then(async (response) => {
				// check for error response (specifically 404)?
				if (!response.ok) {
					// set upvote to zero
					this.setState({ upvotes: 0 });
				} else {
					const data = await response.json();
					this.setState({ upvotes: data.upvotes });
				}
			})
			.catch((error) => {
				// console.error(error);
			});
	}

	// POST
	async upvoteHandler() {
		try {
			const url_id = window.location.pathname.replace(/^\/+/, '');
			console.log(url_id);
			const result = await fetch('https://thumbs.vercel.app/api', {
				method: 'POST',
				mode: 'no-cors',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				// Data sent to API
				body: JSON.stringify({
					action: 'upvote',
					url_id: url_id
				})
			});
			console.log('Result ' + result);
		} catch (e) {
			console.log(e);
		}
	}

	render() {
		let Upvote__button = this.state.unStyled ? 'plainButton' : 'greenButton';
		return (
			<div className="Upvote__container">
				<button
					className={Upvote__button}
					onClick={() => {
						this.upvoteHandler();
						this.colorHandler();
					}}
				>
					<ThumbsUpIcon />
				</button>
				<span>{this.state.upvotes}</span>
			</div>
		);
	}
}

export default Upvote;
